import { useState, useEffect, Fragment } from "react";
import React from "react";
import Section from "./section/section";
import Swiper from "./slider/slider";
import { galleryClients } from "./gallery-clients";
import ContactUs from "../../new-components/contact-us";
import SendUsMessages from "../../new-components/form/send-us-message/index";
// hooks
import {useAcfAboutUs} from "../../hooks/useAcfAboutUs";
// api
import { apiGetMedia } from "../../api/public";
// helpers
import {getAwsS3ImageUrl} from "../../helpers";
// constants
import { aboutAcf } from "../../constants/acf";

/* eslint import/no-webpack-loader-syntax: off */
import SvgDecoration from "-!svg-react-loader!../../icons/about-us-banner-icon.svg";
import SvgReason1 from "-!svg-react-loader!../../icons/reason-1.svg";
import SvgReason2 from "-!svg-react-loader!../../icons/reason-2.svg";
import SvgReason3 from "-!svg-react-loader!../../icons/reason-3.svg";
import SvgReason4 from "-!svg-react-loader!../../icons/reason-4.svg";
import bannerImage from '../../images/about-us-banner.png';
import './style.css';



const AWS_IMAGE_TYPE = 'about-us-slider';
const AboutUsNew = () => {
    const acf = useAcfAboutUs(aboutAcf);
    const [slidersImg, setSlidersImg] = useState([]);


    useEffect(() => {
        let abort = false;
        apiGetMedia(AWS_IMAGE_TYPE).then((data) => {
            if(abort) return;

            const fields = data.map(field => ({
                id: field._id,
                alt: field.createdAt,
                src: getAwsS3ImageUrl(AWS_IMAGE_TYPE, field.name)
            }))
            setSlidersImg(fields);
        })
        return () => {abort = true};
    }, [])
    return (
        <Fragment>
            <Section>
                <h1 className="about-us-banner__title">{acf['intro-title']}</h1>
                <div className="about-us-banner__decoration--90deg">
                    <div className="about-us-banner__decoration-icon">
                        <SvgDecoration/>
                    </div>
                </div>
                <div className="about-us-banner__content">
                    <div className="about-us-banner__image">
                        <div className="about-us-banner__image--wrapper">
                        <div className="about-us-banner__decoration--0deg"></div>
                            <img src={bannerImage}></img>
                        </div>
                    </div>
                    <div
                        className="about-us-banner__text"
                        dangerouslySetInnerHTML={{ __html: acf['intro-description'] }}
                    >

                    </div>
                </div>
            </Section>
            <Swiper  sliders={slidersImg}/>
            <Section>
                <h2 className="about-us__title about-us__clients__title">Some of our clients</h2>
                <div className="about-us-clients__wrap">
                    <ul className="about-us-clients__list">
                        {galleryClients.map(client =>
                            <li className="about-us-clients__item" key={client.id}>
                                <div className="about-us-clients__image--wrapper">
                                    <img src={client.src} alt={client.alt}></img>
                                </div>
                            </li>    
                        )}
                    </ul>
                </div>
            </Section>
            <Section>
                <h2 className="about-us__title about_us__why-us__title">{acf['wcu-title']}</h2>
                <div className="about-us__why-us__reasons">
                    <div className="about-us__why-us__reason">
                        <SvgReason1/>
                        <h3>{acf['wcu-feature-1-title']}</h3>
                        <p>{acf['wcu-feature-1-description']}</p>
                    </div>
                    <div className="about-us__why-us__reason">
                        <SvgReason2/>
                        <h3>{acf['wcu-feature-2-title']}</h3>
                        <p>{acf['wcu-feature-2-description']}</p>
                    </div>
                    <div className="about-us__why-us__reason">
                    <SvgReason3/>
                        <h3>{acf['wcu-feature-3-title']}</h3>
                        <p>{acf['wcu-feature-3-description']}</p>
                    </div>
                    <div className="about-us__why-us__reason">
                    <SvgReason4/>
                        <h3>{acf['wcu-feature-4-title']}</h3>
                        <p>{acf['wcu-feature-4-description']}</p>
                    </div>
                </div>
            </Section>
            <Section>
                <div className="about-us__form--wrap">
                    <ContactUs/>
                    <div className="about-us__form__message--wrap">
                        <SendUsMessages/>
                    </div>
                </div>
            </Section>
        </Fragment>
    );
}

export default AboutUsNew;


// WEBPACK FOOTER //
// ./src/page/about-us/index.js